export const Tabs = () => {
  if (!document.querySelector(".tabs-container")) return;

  const tabsContainers = document.querySelectorAll(".tabs-container");

  function changeTab(tabItem) {
    const tabsContainer = tabItem.closest(".tabs-container");
    const tabLinks = tabsContainer.querySelectorAll(".tab");
    // Change tab state
    for (const tabLink of tabLinks) {
      tabLink.classList.remove("active");
      tabLink.setAttribute("aria-selected", false);
    }
    tabItem.classList.add("active");
    tabItem.setAttribute("aria-selected", true);

    // Change tab content state
    const targetId = tabItem.getAttribute("data-id");
    const tabsContent = tabsContainer.querySelectorAll(".tab-content");
    for (const tabContent of tabsContent) {
      tabContent.classList.remove("active");
      tabContent.setAttribute("aria-hidden", true);
    }
    let targetContainer = tabsContainer.querySelector(
      `.tab-content[data-id="${targetId}"]`
    );
    targetContainer.classList.toggle("active");
    targetContainer.setAttribute("aria-hidden", false);
  }

  if (tabsContainers.length) {
    for (const tabsContainer of tabsContainers) {
      const tabLinks = tabsContainer.querySelectorAll(".tab");

      // * Mouse listener
      for (const tabItem of tabLinks) {
        tabItem.addEventListener("click", function (e) {
          e.stopPropagation();
          changeTab(this);
        });
      }

      // * Keyboard listener
      // ? see: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role
      const tabs = tabsContainer.querySelectorAll('[role="tab"]');
      const tabList = tabsContainer.querySelector('[role="tablist"]');
      let tabFocus = 0;
      tabList.addEventListener("keydown", (e) => {
        // Arrow keys
        if (e.keyCode === 39 || e.keyCode === 37) {
          tabs[tabFocus].setAttribute("tabindex", -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= tabs.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = tabs.length - 1;
            }
          }

          tabs[tabFocus].setAttribute("tabindex", 0);
          tabs[tabFocus].focus();
        }

        // Press enter
        if (e.keyCode === 13 && e.target.closest(".tab")) {
          changeTab(e.target.closest(".tab"));
        }
      });
    }

    // BUT prevent focus on tab content and tabs when using mouse
    document
      .querySelectorAll(".tab")
      .forEach((tab) =>
        tab.addEventListener("mousedown", (e) => e.preventDefault())
      );
    document
      .querySelectorAll(".tab-content")
      .forEach((tabPanel) =>
        tabPanel.addEventListener("mousedown", (e) => e.preventDefault())
      );
  }
};

document.addEventListener("DOMContentLoaded", function () {
  Tabs();
});
